<ng-container *ngIf="notification() as item">
<ng-container *ngIf="item | notificationPresentation as presentation">
  <div class="modal-backdrop fade show important-notification-backdrop"></div>
  <div
    class="modal fade show d-block important-notification-modal"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    aria-labelledby="importantNotificationTitle"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content shadow-lg">
        <div class="modal-header bg-warning-subtle">
          <div>
            <div class="text-uppercase small fw-bold text-warning-emphasis mb-1">{{ presentation.label }}</div>
            <h2 class="modal-title h5 mb-0" id="importantNotificationTitle">{{ item.title }}</h2>
          </div>
          <button
            type="button"
            class="btn-close"
            aria-label="Dismiss important notification"
            (click)="dismiss(item)"
          ></button>
        </div>

        <div class="modal-body">
          <p class="mb-3 notification-message" *ngIf="!presentation.emergency">{{ item.message }}</p>
          <dl class="notification-facts" *ngIf="presentation.fields.length">
            <div *ngFor="let field of presentation.fields"><dt>{{ field.label }}</dt><dd>{{ field.value }}</dd></div>
          </dl>
          <details class="mb-3" *ngIf="presentation.emergency && item.message">
            <summary>Original radio message</summary>
            <p class="notification-message mt-2">{{ item.message }}</p>
          </details>

          <div *ngIf="item.nextSteps?.length" class="mb-3">
            <h3 class="h6">Next steps</h3>
            <ol class="mb-0 ps-3">
              <li *ngFor="let step of item.nextSteps; trackBy: trackByStep">{{ step }}</li>
            </ol>
          </div>

          <div *ngIf="item.actionLinks?.length" class="d-flex flex-wrap gap-2">
            <a
              *ngFor="let link of item.actionLinks; trackBy: trackByLink"
              class="btn btn-primary btn-sm"
              [routerLink]="link.route"
              [queryParams]="link.queryParams || null"
              (click)="dismiss(item)"
            >
              {{ link.label }}
            </a>
          </div>
        </div>

        <div class="modal-footer">
          <a class="btn btn-outline-secondary btn-sm" [routerLink]="['/notifications', item.id]" (click)="dismiss(item)">
            View notification
          </a>
          <button type="button" class="btn btn-warning btn-sm" (click)="dismiss(item)">
            Dismiss
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

</ng-container>
